import React from 'react';
import { BrowserRouter as Router, Link, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import './styles/play.css';

import Home from './components/Home';
import StartGame from './components/StartGame';
import JoinGame from './components/JoinGame';
import GameLobby from './components/GameLobby';
import GameBoard from './components/GameBoard';
import Login from './components/Login';
import Signup from './components/Signup';
import ForgotPassword from './components/ForgotPassword';
import Profile from './components/Profile';
import PrivateRoute from './components/PrivateRoute';
import NotFound from './components/NotFound';
import { AuthProvider } from './context/AuthContext';
import { JuiceProvider } from './context/JuiceContext';

function AppShell() {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const playMode = /\/(game-board|game-lobby)\//.test(location.pathname);
  const boardMode = /\/game-board\//.test(location.pathname);

  return (
    <div className={`app-container${playMode ? ' play-mode' : ''}${boardMode ? ' board-mode' : ''}`}>
      <div className="ss-grain" aria-hidden="true" />
      <a className="ss-skip" href="#main-content">
        Skip to content
      </a>

      <main id="main-content" className="app-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          <Route element={<PrivateRoute />}>
            <Route path="/profile" element={<Profile />} />
            <Route path="/start-game" element={<StartGame />} />
            <Route path="/join-game" element={<JoinGame />} />
            <Route path="/join" element={<JoinGame />} />
            <Route path="/game-lobby/:gameId" element={<GameLobby />} />
            <Route path="/game-board/:gameId" element={<GameBoard />} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      <footer className="app-footer">
        <p>
          <Link to="/">Home</Link>
          {' · '}
          &copy; {currentYear} Spin &amp; Solve
        </p>
      </footer>
    </div>
  );
}

function App() {
  return (
    <JuiceProvider>
      <AuthProvider>
        <Router>
          <AppShell />
        </Router>
      </AuthProvider>
    </JuiceProvider>
  );
}

export default App;
